import { useState } from "react";

import { FormattedMessage } from "react-intl";

import { LoadingButton } from "@atlaskit/button";
import { FormFooter } from "@atlaskit/form";
import Heading from "@atlaskit/heading";
import { Box, Flex, Stack, xcss } from "@atlaskit/primitives";

import { PageBoardColumnsLeftProps } from "../../../common/types.tsx";

import messages from "./messages.tsx";
import { ColumnInputs, onClickFinishButton } from "./utils.tsx";

export const LeftHandSidePageBoardColumns = ({
    onClickNext,
    columnNames,
    setColumnNames
}: PageBoardColumnsLeftProps) => {
    const [emptyInputIndexes, setEmptyInputIndexes] = useState<number[]>([]);
    const [dupeIndexes, setDupeIndexes] = useState<number[]>([]);
    const [exceededInputLengthIndexes, setExceededInputLengthIndexes] =
        useState<number[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onClickNextWrapper = ({ columnNames }: { columnNames: string[] }) => {
        onClickNext({ columnNames });
        setIsSubmitting(true);
    };

    return (
        <>
            <Stack space="space.200">
                <Heading size="xlarge" as="h1">
                    <FormattedMessage {...messages.title} />
                </Heading>
                <Box xcss={subtextStyles}>
                    <FormattedMessage {...messages.subtitle} />
                </Box>
                <ColumnInputs
                    columnNames={columnNames}
                    setColumnNames={setColumnNames}
                    emptyInputIndexes={emptyInputIndexes}
                    setEmptyInputIndexes={setEmptyInputIndexes}
                    dupeIndexes={dupeIndexes}
                    setDupeIndexes={setDupeIndexes}
                    exceededInputLengthIndexes={exceededInputLengthIndexes}
                    setExceededInputLengthIndexes={
                        setExceededInputLengthIndexes
                    }
                />
            </Stack>
            <FormFooter>
                <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    xcss={footerStyles}
                >
                    <FormattedMessage {...messages.step} />

                    <LoadingButton
                        appearance="primary"
                        onClick={() => {
                            onClickFinishButton({
                                onClickNext: onClickNextWrapper,
                                columnNames,
                                setEmptyInputIndexes,
                                setDupeIndexes,
                                setExceededInputLengthIndexes
                            });
                        }}
                        isLoading={isSubmitting}
                    >
                        <FormattedMessage {...messages.finishButtonCta} />
                    </LoadingButton>
                </Flex>
            </FormFooter>
        </>
    );
};

const subtextStyles = xcss({
    fontSize: "font.body.medium",
    color: "color.text.subtle"
});

const footerStyles = xcss({
    width: "100%",
    color: "color.text.subtlest"
});
